export const INSPIRE_RESULTS_COUNT = 24;